import React from 'react';

import './AnalyticsPlatformTmxSearchOverview.scss';

import Tooltips from '../../atoms/Tooltip/Tooltip';

// import * as moment from 'moment';

const AnalyticsPlatformTmxSearchOverview = ({ loading, responseData, overallDataSetType }) => {
  return (
    <>
      <div className="tmx-analyticsPlatformTmxSearchOverview__clearedGrid tmx-analyticsPlatformTmxSearchOverview__clearedGrid--top">
        {loading ? (
          <div className="tmx-analyticsPlatformTmxSearchOverview__clearedBubble tmx-analyticsPlatformTmxSearchOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--number"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsPlatformTmxSearchOverview__clearedBubble tmx-analyticsPlatformTmxSearchOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="Users engaging with TMX within a specific amount of time."
              direction="bottom">
              <h1 className="tmx-analyticsPlatformTmxSearchOverview__basicInfoTopTitle">
                {responseData?.search?.total_searches}
              </h1>
              <h1 className="tmx-analyticsPlatformTmxSearchOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Total searches
                <br />
              </h1>
            </Tooltips>
          </div>
        )}

        {loading ? (
          <div className="tmx-analyticsPlatformTmxSearchOverview__clearedBubble tmx-analyticsPlatformTmxSearchOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--number"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsPlatformTmxSearchOverview__clearedBubble tmx-analyticsPlatformTmxSearchOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="Newsrooms engaging with TMX within a specific amount of time."
              direction="bottom">
              <h1 className="tmx-analyticsPlatformTmxSearchOverview__basicInfoTopTitle">
                {responseData?.search?.total_users}
              </h1>
              <h1 className="tmx-analyticsPlatformTmxSearchOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Total search users
                <br />
                {/* (Unique) */}
              </h1>
            </Tooltips>
          </div>
        )}

        {loading ? (
          <div className="tmx-analyticsPlatformTmxSearchOverview__clearedBubble tmx-analyticsPlatformTmxSearchOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--number"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsPlatformTmxSearchOverview__clearedBubble tmx-analyticsPlatformTmxSearchOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="New user accounts created with TMX."
              direction="bottom">
              <h1 className="tmx-analyticsPlatformTmxSearchOverview__basicInfoTopTitle">
                {responseData?.search?.nr_users}
              </h1>
              <h1 className="tmx-analyticsPlatformTmxSearchOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Newsroom users
                <br />
                (Unique)
              </h1>
            </Tooltips>
          </div>
        )}

        {loading ? (
          <div className="tmx-analyticsPlatformTmxSearchOverview__clearedBubble tmx-analyticsPlatformTmxSearchOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--number"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsPlatformTmxSearchOverview__clearedBubble tmx-analyticsPlatformTmxSearchOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="New newsroom accounts created with TMX."
              direction="bottom">
              <h1 className="tmx-analyticsPlatformTmxSearchOverview__basicInfoTopTitle">
                {responseData?.search?.biz_users}
              </h1>
              <h1 className="tmx-analyticsPlatformTmxSearchOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Business users
                <br />
                (Unique)
              </h1>
            </Tooltips>
          </div>
        )}
      </div>

      <div className="tmx-analyticsNetworkBusinessOverview__topTextContainer">
        <div className="tmx-analyticsNetworkBusinessOverview__topTextContainerLeft">
          <h1 className="tmx-analyticsNetworkBusinessOverview__topTextTitle">
            TMX search newsroom KPIs
          </h1>
          <h1 className="tmx-analyticsNetworkBusinessOverview__topTextSubTitle">
            This information is confidential.{' '}
          </h1>
        </div>
      </div>
      <div className="tmx-analyticsPlatformTmxSearchOverview__clearedGrid tmx-analyticsPlatformTmxSearchOverview__clearedGrid--top">
        {loading ? (
          <div className="tmx-analyticsPlatformTmxSearchOverview__clearedBubble tmx-analyticsPlatformTmxSearchOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--number"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsPlatformTmxSearchOverview__clearedBubble tmx-analyticsPlatformTmxSearchOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="Users engaging with TMX within a specific amount of time."
              direction="bottom">
              <h1 className="tmx-analyticsPlatformTmxSearchOverview__basicInfoTopTitle">
                {responseData?.search?.nr_searches}
              </h1>
              <h1 className="tmx-analyticsPlatformTmxSearchOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Newsroom searches
                <br />
              </h1>
            </Tooltips>
          </div>
        )}

        {loading ? (
          <div className="tmx-analyticsPlatformTmxSearchOverview__clearedBubble tmx-analyticsPlatformTmxSearchOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--number"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsPlatformTmxSearchOverview__clearedBubble tmx-analyticsPlatformTmxSearchOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="Newsrooms engaging with TMX within a specific amount of time."
              direction="bottom">
              <h1 className="tmx-analyticsPlatformTmxSearchOverview__basicInfoTopTitle">
                {responseData?.search?.nr_first_timers}
              </h1>
              <h1 className="tmx-analyticsPlatformTmxSearchOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Newsroom first timers
                <br />
                {/* (Unique) */}
              </h1>
            </Tooltips>
          </div>
        )}

        {loading ? (
          <div className="tmx-analyticsPlatformTmxSearchOverview__clearedBubble tmx-analyticsPlatformTmxSearchOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--number"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsPlatformTmxSearchOverview__clearedBubble tmx-analyticsPlatformTmxSearchOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="New user accounts created with TMX."
              direction="bottom">
              <h1 className="tmx-analyticsPlatformTmxSearchOverview__basicInfoTopTitle">
                {responseData?.search?.nr_two_day_streaks}
              </h1>
              <h1 className="tmx-analyticsPlatformTmxSearchOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Newsroom two day streak
                <br />
                (Unique)
              </h1>
            </Tooltips>
          </div>
        )}

        {loading ? (
          <div className="tmx-analyticsPlatformTmxSearchOverview__clearedBubble tmx-analyticsPlatformTmxSearchOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--number"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsPlatformTmxSearchOverview__clearedBubble tmx-analyticsPlatformTmxSearchOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="New newsroom accounts created with TMX."
              direction="bottom">
              <h1 className="tmx-analyticsPlatformTmxSearchOverview__basicInfoTopTitle">
                {responseData?.search?.nr_back_after_while}
              </h1>
              <h1 className="tmx-analyticsPlatformTmxSearchOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Newsroom back after while
                <br />
                (Unique)
              </h1>
            </Tooltips>
          </div>
        )}
      </div>

      <div className="tmx-analyticsNetworkBusinessOverview__topTextContainer">
        <div className="tmx-analyticsNetworkBusinessOverview__topTextContainerLeft">
          <h1 className="tmx-analyticsNetworkBusinessOverview__topTextTitle">
            TMX search business KPIs
          </h1>
          <h1 className="tmx-analyticsNetworkBusinessOverview__topTextSubTitle">
            This information is confidential.{' '}
          </h1>
        </div>
      </div>
      <div className="tmx-analyticsPlatformTmxSearchOverview__clearedGrid tmx-analyticsPlatformTmxSearchOverview__clearedGrid--top">
        {loading ? (
          <div className="tmx-analyticsPlatformTmxSearchOverview__clearedBubble tmx-analyticsPlatformTmxSearchOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--number"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsPlatformTmxSearchOverview__clearedBubble tmx-analyticsPlatformTmxSearchOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="Users engaging with TMX within a specific amount of time."
              direction="bottom">
              <h1 className="tmx-analyticsPlatformTmxSearchOverview__basicInfoTopTitle">
                {responseData?.search?.biz_searches}
              </h1>
              <h1 className="tmx-analyticsPlatformTmxSearchOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Business searches
                <br />
              </h1>
            </Tooltips>
          </div>
        )}

        {loading ? (
          <div className="tmx-analyticsPlatformTmxSearchOverview__clearedBubble tmx-analyticsPlatformTmxSearchOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--number"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsPlatformTmxSearchOverview__clearedBubble tmx-analyticsPlatformTmxSearchOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="Newsrooms engaging with TMX within a specific amount of time."
              direction="bottom">
              <h1 className="tmx-analyticsPlatformTmxSearchOverview__basicInfoTopTitle">
                {responseData?.search?.biz_first_timers}
              </h1>
              <h1 className="tmx-analyticsPlatformTmxSearchOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Business first timers
                <br />
                {/* (Unique) */}
              </h1>
            </Tooltips>
          </div>
        )}

        {loading ? (
          <div className="tmx-analyticsPlatformTmxSearchOverview__clearedBubble tmx-analyticsPlatformTmxSearchOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--number"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsPlatformTmxSearchOverview__clearedBubble tmx-analyticsPlatformTmxSearchOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="New user accounts created with TMX."
              direction="bottom">
              <h1 className="tmx-analyticsPlatformTmxSearchOverview__basicInfoTopTitle">
                {responseData?.search?.biz_two_day_streaks}
              </h1>
              <h1 className="tmx-analyticsPlatformTmxSearchOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Business two day streak
                <br />
                (Unique)
              </h1>
            </Tooltips>
          </div>
        )}

        {loading ? (
          <div className="tmx-analyticsPlatformTmxSearchOverview__clearedBubble tmx-analyticsPlatformTmxSearchOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--number"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
            <div className="tmx-analyticsPlatformTmxSearchOverview__titleMock tmx-analyticsPlatformTmxSearchOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsPlatformTmxSearchOverview__clearedBubble tmx-analyticsPlatformTmxSearchOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="New newsroom accounts created with TMX."
              direction="bottom">
              <h1 className="tmx-analyticsPlatformTmxSearchOverview__basicInfoTopTitle">
                {responseData?.search?.biz_back_after_while}
              </h1>
              <h1 className="tmx-analyticsPlatformTmxSearchOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Business back after while
                <br />
                (Unique)
              </h1>
            </Tooltips>
          </div>
        )}
      </div>
    </>
  );
};

AnalyticsPlatformTmxSearchOverview.propTypes = {};

export default AnalyticsPlatformTmxSearchOverview;
